import { render, staticRenderFns } from "./add-extend.vue?vue&type=template&id=0aa81612&scoped=true&"
import script from "./add-extend.vue?vue&type=script&lang=js&"
export * from "./add-extend.vue?vue&type=script&lang=js&"
import style0 from "./add-extend.vue?vue&type=style&index=0&id=0aa81612&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa81612",
  null
  
)

export default component.exports